import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { createLink } from '@src/util/createLink';
import { FUNNEL_ROUTE } from '@src/Routes/links';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { isInactive } from '@src/util/opening';
import { QueryParams } from '../../interfaces/queryParams.interface';
import { ActiveView } from '../../enums/activeView.enum';
import { ApplicantCountsProps } from './props';
import './styles.scss';

export const ApplicantCounts: FC<ApplicantCountsProps> = ({
  recommended,
  pending,
  inConversation,
  openingId,
  openingState,
  unreadMessagesCount,
  totalShortlist,
  unreadShortlistApplicants,
}) => {
  const { queryParams } = useQueryParams<QueryParams>();

  const activeView = queryParams?.activeView;

  const isOpeningInactive = isInactive(openingState);

  return (
    <div className="opening-header-applicant-counts">
      {!isOpeningInactive && (
        <div
          className={classnames(
            'opening-header-applicant-counts__section',
            'opening-header-applicant-counts__section--large',
            (activeView === ActiveView.INVITE_CANDIDATES || !activeView) &&
              'opening-header-applicant-counts__section--active',
          )}
        >
          <div className="opening-header-applicant-counts__section-wrapper">
            <div className="opening-header-applicant-counts__section-count">{recommended}</div>

            <Link
              className="opening-header-applicant-counts__section-link"
              replace
              to={createLink(FUNNEL_ROUTE, {
                params: { openingId },
                queryParams: { activeView: ActiveView.INVITE_CANDIDATES },
              })}
            >
              Invite candidates
            </Link>
          </div>

          <div className="opening-header-applicant-counts__divider">
            <div className="opening-header-applicant-counts__divider-box opening-header-applicant-counts__divider-box--top" />

            <div className="opening-header-applicant-counts__divider-box opening-header-applicant-counts__divider-box--bottom" />
          </div>
        </div>
      )}

      <div
        className={classnames(
          'opening-header-applicant-counts__section',
          'opening-header-applicant-counts__section--large',
          activeView === ActiveView.PENDING_INVITES && 'opening-header-applicant-counts__section--active',
        )}
      >
        <div className="opening-header-applicant-counts__section-wrapper">
          <div className="opening-header-applicant-counts__section-count">{pending}</div>

          <Link
            className="opening-header-applicant-counts__section-link"
            replace
            to={createLink(FUNNEL_ROUTE, {
              params: { openingId },
              queryParams: { activeView: ActiveView.PENDING_INVITES },
            })}
          >
            Pending invites
          </Link>
        </div>

        <div className="opening-header-applicant-counts__divider">
          <div className="opening-header-applicant-counts__divider-box opening-header-applicant-counts__divider-box--top" />

          <div className="opening-header-applicant-counts__divider-box opening-header-applicant-counts__divider-box--bottom" />
        </div>
      </div>

      <div
        className={classnames(
          'opening-header-applicant-counts__section',
          activeView === ActiveView.IN_SHORTLIST && 'opening-header-applicant-counts__section--active',
        )}
      >
        <div className="opening-header-applicant-counts__section-wrapper">
          <div className="opening-header-applicant-counts__section-count">{totalShortlist}</div>

          <Link
            className="opening-header-applicant-counts__section-link"
            replace
            to={createLink(FUNNEL_ROUTE, {
              params: { openingId },
              queryParams: { activeView: ActiveView.IN_SHORTLIST },
            })}
          >
            In shortlist
          </Link>
        </div>

        <div className="opening-header-applicant-counts__unread-count fade-in">{unreadShortlistApplicants}</div>

        <div className="opening-header-applicant-counts__divider">
          <div className="opening-header-applicant-counts__divider-box opening-header-applicant-counts__divider-box--top" />

          <div className="opening-header-applicant-counts__divider-box opening-header-applicant-counts__divider-box--bottom" />
        </div>
      </div>

      <div
        className={classnames(
          'opening-header-applicant-counts__section',
          activeView === ActiveView.IN_CONVERSATION && 'opening-header-applicant-counts__section--active',
        )}
      >
        <div className="opening-header-applicant-counts__section-wrapper">
          <div className="opening-header-applicant-counts__in-conversation-wrapper">
            <div className="opening-header-applicant-counts__section-count">{inConversation}</div>
          </div>

          <Link
            className="opening-header-applicant-counts__section-link"
            replace
            to={createLink(FUNNEL_ROUTE, {
              params: { openingId },
              queryParams: { activeView: ActiveView.IN_CONVERSATION },
            })}
          >
            In conversation
          </Link>

          {!!unreadMessagesCount && (
            <div className="opening-header-applicant-counts__unread-count fade-in">{unreadMessagesCount}</div>
          )}
        </div>
      </div>
    </div>
  );
};
